(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-drawer-menu]');
    if (!drawer) return;
    const panel = drawer.querySelector('.drawer-menu__panel');
    if (!panel) return;
    const owner = drawer.closest('.shopify-section');
    const header = drawer.closest('header.header');
    const viewport = window.visualViewport;
    const key = '__cascasMenuViewport';
    if (window[key]) window[key]();
    let frame = 0;
    let disposed = false;
    const clear = () => {
      drawer.style.removeProperty('--cascas-menu-height');
      drawer.style.removeProperty('--cascas-menu-content-height');
      drawer.style.removeProperty('--cascas-menu-header-space');
    };
    const update = () => {
      if (disposed || !drawer.isConnected) return;
      if (!drawer.classList.contains('active') || window.innerWidth > 1200) {
        clear();
        return;
      }
      if (viewport && Math.abs(viewport.scale - 1) > 0.01) return;
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const top = drawer.getBoundingClientRect().top;
      const height = Math.ceil(bottom - top);
      if (!Number.isFinite(height) || height <= 0) return;
      if (header) {
        const space = Math.max(0, header.getBoundingClientRect().bottom - top);
        if (Number.isFinite(space)) {
          const pixels = space + 'px';
          if (drawer.style.getPropertyValue('--cascas-menu-header-space') !== pixels) drawer.style.setProperty('--cascas-menu-header-space', pixels);
        }
      }
      const style = getComputedStyle(panel);
      const content = Math.max(0, height - (parseFloat(style.paddingTop) || 0) - (parseFloat(style.paddingBottom) || 0));
      for (const [name, value] of [['--cascas-menu-height', height], ['--cascas-menu-content-height', content]]) {
        const pixels = value + 'px';
        if (drawer.style.getPropertyValue(name) !== pixels) drawer.style.setProperty(name, pixels);
      }
    };
    const schedule = () => {
      if (disposed || !drawer.classList.contains('active')) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        update();
      });
    };
    const observer = new MutationObserver(() => {
      update();
      schedule();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    const unload = event => {
      if (event.target === owner) dispose();
    };
    const dispose = () => {
      disposed = true;
      cancelAnimationFrame(frame);
      observer.disconnect();
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('pageshow', schedule);
      if (viewport) {
        viewport.removeEventListener('resize', schedule);
        viewport.removeEventListener('scroll', schedule);
      }
      document.removeEventListener('shopify:section:unload', unload);
      clear();
      if (window[key] === dispose) delete window[key];
    };
    window[key] = dispose;
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    if (viewport) {
      viewport.addEventListener('resize', schedule, { passive: true });
      viewport.addEventListener('scroll', schedule, { passive: true });
    }
    document.addEventListener('shopify:section:unload', unload);
    if (document.fonts) document.fonts.ready.then(schedule);
    update();
  })();

  (() => {
    const lists = [...document.querySelectorAll('.drawer-menu__list--sub')]
      .filter(list => list.querySelector('.has-summary-image'));
    if (!lists.length) return;
    let frame;
    const updateHeight = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        for (const list of lists) {
          if (!list.classList.contains('visible') || list.getAttribute('aria-hidden') === 'true') continue;
          const main = list.closest('.drawer-menu__main');
          if (main) main.style.height = Math.ceil(list.getBoundingClientRect().height) + 'px';
        }
      });
    };
    const observer = new ResizeObserver(updateHeight);
    lists.forEach(list => observer.observe(list));
    window.addEventListener('resize', updateHeight, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
